export default __webpack_public_path__ + "static/contact-img-b0b2239d14e1b7f09d09cc5cbb832271.jpg";